// import 'react-pro-sidebar/dist/css/styles.css';
import './DefaultLayout.scss'
import { Header } from "../components/header";
import { SlideBar } from "../components/slideBar";
import { useProSidebar } from 'react-pro-sidebar';
import { useEffect, useState } from 'react';

const DefaultLayout = ({ children }) => {
    const { collapsed } = useProSidebar();
    const [sidebarWidth, setSidebarWidth] = useState(250);

    useEffect(() => {
        // Adjust content margin based on sidebar collapse state
        setSidebarWidth(collapsed ? 80 : 250);
    }, [collapsed]);

    return (
        <div id="default-layout">
            <div className="slidebar">
                <SlideBar />
            </div>
            <div className="content" style={{ marginLeft: `${sidebarWidth}px` }}>
                <Header />
                <div>{children}</div>
            </div>
        </div>
    )
}

export default DefaultLayout;